import { HStack } from '@chakra-ui/react';
import { Badge } from '@diamond/shared/ui';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { AdminPaymentProofOcrStatus } from '../../types/payment-proof-ocr';

interface PaymentProofOcrStatusLabelProps {
  status: AdminPaymentProofOcrStatus;
}

const statusLabelConfig = {
  success: {
    label: 'Sesuai',
    bg: '#CBFAD9',
    color: '#157A38',
    icon: CheckCircleOutlineIcon,
  },
  warning: {
    label: 'Perhatian!',
    bg: '#FFF4D6',
    color: '#FF7A00',
    icon: ErrorOutlineIcon,
  },
};

export function PaymentProofOcrStatusLabel({
  status,
}: PaymentProofOcrStatusLabelProps) {
  const config = statusLabelConfig[status];
  const Icon = config.icon;

  return (
    <Badge
      bg={config.bg}
      color={config.color}
      borderRadius="10px"
      px={2.5}
      py={1.5}
      textTransform="none"
      fontSize="14px"
      fontWeight="700"
      data-testid={`payment-proof-ocr-status-${status}`}
    >
      <HStack spacing={1.5}>
        <Icon fontSize="small" />
        <span>{config.label}</span>
      </HStack>
    </Badge>
  );
}
